import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import SplashLoader from "@/components/SplashLoader";
import { isKolektorAllowedPath, landingPathFor } from "@/lib/billing";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready) {
    return <SplashLoader label="Memuat sesi..." />;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  // Feb 2026 — Route protection untuk primary role KOLEKTOR. Kolektor
  // tidak boleh membuka Dashboard Operasional atau route non-billing
  // lain hanya dengan mengetik URL. Backend RBAC (Billing) tetap
  // sumber kebenaran; guard ini hanya cegah render UI yang tidak boleh
  // mereka lihat.
  if (user.role === "kolektor" && !isKolektorAllowedPath(location.pathname)) {
    return <Navigate to={landingPathFor(user)} replace />;
  }
  return children;
}
